import { html } from "../../helpers/html-template.js";
import { EditorClasses } from "../../styles.js";
import { toVueComponent } from "@scalar-org/vue-render";
function guideCodeBlockHtml({
  lang,
  maxHeight,
  minHeight,
  lineNumbers,
  lineNumberStart,
  highlight,
  focus,
  added,
  removed,
  fullHeight = false,
  isEditable = false
}) {
  const classes = [EditorClasses.Code, "custom-code"];
  if (fullHeight) classes.push("code__fullheight");
  if (!fullHeight) classes.push("custom-scroll");
  if (lineNumbers) classes.push("t-code--numbered");
  if (focus) classes.push("t-code--focused");
  const inner = html`<code class="hljs language-${lang}" language="${lang}"><ssg-children></ssg-children></code>`;
  let style = "position: relative;";
  if (maxHeight && !fullHeight) style += `max-height: ${maxHeight};`;
  if (minHeight) style += `min-height: ${minHeight};`;
  return html`
<div class="${EditorClasses.CodeContainer}" style="position: relative;">
  <pre style="${style}" 
    class="${classes.join(" ")}" 
    data-focus="${focus}"
    data-highlight="${highlight}"
    data-added="${added}"
    data-removed="${removed}"
    data-line-number-start="${lineNumberStart?.toString()}">${inner}</pre>
  ${!isEditable && languageButtonHtml({ lang })}
</div>
`;
}
function languageButtonHtml({ lang }) {
  const classes = ["language-button", EditorClasses.LanguagePicker].join(" ");
  return html`
  <button
    class="${classes}"
    data-scalar-type="code-block-copy"
    type="button">
    ${lang}
    <svg class="lang-copy" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256"><path d="M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z"></path></svg>
    <svg class="lang-success" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 256 256"><path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"></path></svg>
  </button>
  `;
}
const ScalarCodeBlockVue = toVueComponent(guideCodeBlockHtml, {
  lang: String,
  fullHeight: Boolean,
  isEditable: Boolean
});
export {
  ScalarCodeBlockVue,
  guideCodeBlockHtml
};
//# sourceMappingURL=component.js.map
